import React, {Component} from 'react';
import Prismic from 'prismic-javascript';
import { PrismicConfig } from '../../../../helpers/prismicHelpers/PrismicAPI';
import { LanguagePrismicHelper } from '../../../../helpers/prismicHelpers/PrismicHelpers'
import { prismicSliceHelper, prismicSliceContentRelationship } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers';
import { sliceComponentsHelper } from '../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers';
import Loader from '../../../common/elements/Loader';

class CookiesPage extends Component {

	state = {
        slices: null
    }

    async componentDidMount () {
		window.scrollTo(0, 0);
		const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, { accessToken: PrismicConfig.apiAccessTokes });
        const json = await prismicConnection.query(Prismic.Predicates.at('my.flexible-layout.uid', 'cookie-policy'), LanguagePrismicHelper());
        let { slices } = prismicSliceHelper(json);
        slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection) : null;
        this.setState({slices});
	}
	
	shouldComponentUpdate(nextProps, nextState) {
        return this.state.slices !== nextState.slices
    }

	render() {

		const { slices } = this.state;

        if(!slices) return <Loader />

        return (
            <section>
                {sliceComponentsHelper(slices)}
            </section>
		)
		
	}
}

export default CookiesPage;


// WEBPACK FOOTER //
// src/client/components/site/features/legal/CookiesPage.js